import { num } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const LocationLimits = ({ item, value, onChange }) => {
  const { meta } = useAuth();
  const locs = meta.locations.filter((l) => l.active !== false && ["warehouse", "outlet"].includes(l.type));
  const set = (id, k, v) => onChange({ ...value, [id]: { ...(value[id] || {}), [k]: v } });
  const defMin = (l) => (l.type === "warehouse" ? Number(item.warehouse_min_stock) || Number(item.min_stock) || 0 : Number(item.min_stock) || 0);
  return (
    <div data-testid="location-limits">
      <div className="text-xs font-bold uppercase tracking-wide text-slate-600 mb-1">Batas stok per lokasi ({item.base_unit})</div>
      <div className="text-xs text-slate-500 mb-2">Kosongkan untuk memakai nilai default barang.</div>
      <div className="border rounded-md divide-y">
        {locs.map((l) => (
          <div key={l.id} className="grid grid-cols-12 gap-2 items-center px-3 py-1.5">
            <span className="col-span-6 text-sm font-medium">{l.name} <span className="text-[10px] uppercase text-slate-400">{l.type === "warehouse" ? "gudang" : "outlet"}</span></span>
            <input className="inp !h-8 col-span-3 num" type="number" step="any" min="0" placeholder={`Min ${num(defMin(l))}`} value={value[l.id]?.min ?? ""} onChange={(e) => set(l.id, "min", e.target.value)} data-testid={`limit-min-${l.code || l.id}`} />
            <input className="inp !h-8 col-span-3 num" type="number" step="any" min="0" placeholder={`Maks ${num(item.max_stock || 0)}`} value={value[l.id]?.max ?? ""} onChange={(e) => set(l.id, "max", e.target.value)} data-testid={`limit-max-${l.code || l.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
};
